export default __webpack_public_path__ + "static/media/Visual_joil_05.ae91dd02.jpg";